import { render, staticRenderFns } from "./consoleMenu.vue?vue&type=template&id=118a359f&scoped=true"
import script from "./consoleMenu.vue?vue&type=script&lang=js"
export * from "./consoleMenu.vue?vue&type=script&lang=js"
import style0 from "./consoleMenu.vue?vue&type=style&index=0&id=118a359f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a359f",
  null
  
)

export default component.exports